import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import './BookMore.scss';

const BookMore = ({ text }) => (
  <>
    <div className="book-more-text">{text}</div>
    <div className="book-more-icon">
      <FontAwesomeIcon icon={faPlus} size="lg" />
    </div>
  </>
);

BookMore.propTypes = {
  text: PropTypes.string.isRequired,
};

export default BookMore;
